
<div class="row" id="cancel-row">
    <div class="col-xl-12 col-lg-12 col-sm-12  layout-spacing">
        <div class="statbox widget box box-shadow">
            <div class="widget-header">
                <div class="row">          
                </div>
            </div>
            <div class="widget-content widget-content-area">
                <div class="table-responsive mb-4">
                    <div *ngIf="loading_team" class="cp-spinner cp-bubble" style="margin: auto;display: block;margin-top: 20%;
                                margin-bottom: 20%;"></div>
                    <table *ngIf="!loading_team" id="alter_pagination_" class="table table-striped table-bordered table-hover" style="width:100%">
                        <thead>
                            <tr>
                                <th>Membre</th>
                                <th>Téléphone</th>
                                <th>Date d'ajout</th>
                                <th>Email</th>
                                <th>Ville</th>
                                <th>Profil</th>
                                <th>Etat actuel</th>
                                <th>Status</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let member of team" id="{{member.uuid}}">
                                <td>
                                    <a href="javascript:void(0);" data-toggle="modal" data-target="#gererModal" 
                                        (click)="Commercial(member.uuid)" style="color:blue;">
                                        {{member.fullname}}</a></td>
                                <td>{{member.phone || '---'}}</td>
                                <td><span *ngIf="member.added_at == null">---</span>{{member.added_at  | date: 'dd/MM/yyyy - HH:mm '}}</td>
                                <td>{{member.email || '---'}}</td>
                                <td>{{member.city || '---'}}</td>
                                <td>{{getProfile(member.profile)}}</td>
                                <td><span *ngIf="member.state == null">Libre</span>{{member.state}}</td>
                                <td id="status-{{member.uuid}}">
                                    <span *ngIf="member.status == true">Actif</span>
                                    <span *ngIf="member.status == false"> Non actif</span></td>
                                <td class="text-center">
                                    <div class="row" style="display: inline-flex;">
                                         <a class="dropdown-toggle" href="/sales/member;cr={{member.uuid}}" role="button"
                                            title="Ventes" >
                                            <i class="flaticon-dollar-coin text-success" style="font-size: large;"></i>
                                        </a>
                                        <div class="dropdown custom-dropdown" style="width: min-content;">
                                            <a class="dropdown-toggle" href="#" role="button" id="dropdownMenuLink1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                                                <i class="flaticon-dot-three"></i>
                                            </a>
                                            <div class="dropdown-menu" aria-labelledby="dropdownMenuLink1">
                                                <a class="dropdown-item" href="javascript:void(0);" data-toggle="modal" data-target="#gererModal"
                                                (click)="Commercial(member.uuid)">Gérer</a>
                                                <a class="dropdown-item" href="javascript:void(0);" *ngIf="getProfile(member.profile)=='Commercial'" (click)="getTeamid(member)"
                                                    data-toggle="modal" data-target="#planningmodal">Voir le programme</a>
                                                <a class="dropdown-item" href="javascript:void(0);" *ngIf="getProfile(member.profile)=='Commercial'" data-toggle="modal" data-target="#historymodal"
                                                    (click)="getActionsMember(member.uuid,member.fullname)" >Historique</a>
                                            </div>
                                        </div>
                                    </div>
                                   
                                </td>
                            </tr>
                    </table>
                </div>
            </div>
        </div>    
    </div>
</div>
<div id="gererModal" class="modal animated fadeInUp custo-fadeInUp" role="dialog">
    <div class="modal-dialog modal-xl">
        <!-- Modal content-->
        <div class="modal-content">
            <div class="alert alert-gradient" id="successSave" role="alert" style="opacity: 0;z-index: 100;display: none;"> 
                <i class="flaticon-cancel-12 close ml-3" data-dismiss="alert"></i> 
                <strong>Succes </strong> Acces de {{commercial_fullname}} est
                <span *ngIf="commercial_status == 'cff182167d5017c13d5178ca1836f2a7'">activé</span>
                <span *ngIf="commercial_status == '9dbecf2631b52926e5dd1a89440ef908'">desactivé</span>
            </div>
            <div class="alert alert-gradient alert-danger" id="error" role="alert" style="opacity: 0;z-index: 100;
                display: none;background-image: linear-gradient(135deg,#8f3038ed 0,#e6000cc4 100%) !important;"> 
                <i class="flaticon-cancel-12 close ml-3" data-dismiss="alert"></i> 
                <strong>Echouée</strong> Erreur de generation de Pdf</div> 
        <div class="modal-content" style="background-color:#e0e0e0 !important;">
            <div class="modal-body">
                <div *ngIf="loading_indicator" class="cp-spinner cp-bubble" style="margin: auto;display: block;margin-top: 20%;
                                        margin-bottom: 20%;"></div>

                <div *ngIf="!loading_indicator" class="row  box box-shadow pr-3" style="margin-left: 1%;">
                    <div id="container" class="widget-content widget-content-area images_pop_detail_team m-2 mr-3 area_popin col-xl-4 col-lg-4 col-md-12 col-sm-4">
                        <img *ngIf="commercial_avatar!=null && commercial_avatar!=undefined" [src]="'data:image/jpg;base64,'+commercial_avatar" 
                            class="images_pop_detail_team" width="100%" style="height:100%">
                        <img *ngIf="commercial_avatar==null || commercial_avatar==undefined" src="../../../assets/img/unknown_user.jpg" 
                            class="images_pop_detail_team" width="100%" style="height:100%;width: 105% !important;">
                        <div class="top-center row " style="margin-left: auto;"><h4 style="color: white !important;">{{commercial_fullname}}</h4>  
                            <div class="icon">
                                <span class="flaticon-checked-2 h5"></span> 
                            </div>
                        </div>
                    </div>
                    <div class="widget-content widget-content-area area_popin col-xl-7 col-lg-7 col-md-12 col-sm-8"
                        style="border-radius: 60px 20px 60px 20px;">
                        <div class="col-xl-12 col-lg-12 col-sm-12" *ngIf="getProfile(commercial_profile)=='Commercial'">
                            <div class="col-xl-6 col-lg-6 col-sm-12 pl-0 pb-3" id="left">
                                <div class="widget-content-area  data-widgets pl-0 br-4">
                                    <div class="widget  t-sales-widget">
                                        <div class="media">
                                            <div class="icon ml-2 ">
                                                <!-- <i class="flaticon-cart-2"></i> -->
                                                <i class="flaticon-car" style="background-color: #5ad7ff;color: black;"></i>
                                            </div>
                                            <div class="">
                                                <p class="widget-text mb-0 " style="color: black; font-size: 20px;">Visites Planifiées</p>
                                                <b class="widget-numeric-value" style="font-size: 20px;"><span *ngIf="commercial_sells == null">0</span>{{commercial_sells}}</b>
                                            </div>
                                        </div>  
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-6 col-lg-6 col-sm-12 pl-0 pb-3" id="right">
                                <div class="widget-content-area  data-widgets pl-0 br-4">
                                    <div class="widget  t-order-widget">
                                        <div class="media">
                                            <div class="icon ml-2 ">
                                                <i class="flaticon-car"></i>
                                                <!-- <i class="flaticon-loading-1"></i> -->
                                            </div>
                                            <div class="">
                                                <p class="widget-text mb-0 " style="color: black; font-size: 20px;">Dernier Déplacement</p>
                                                <b *ngIf="last_visit!=''" class="widget-numeric-value" style="font-size: 20px;">{{last_visit}}</b>
                                                <span *ngIf="last_visit==''"class="widget-numeric-value" style="font-size: 20px;">Aucun déplacement</span>
                                            </div>
                                        </div>  
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div style="margin-top:2%" class="col-xl-12 col-lg-12 col-sm-12" *ngIf="getProfile(commercial_profile)=='Commercial'">
                            <div class="col-xl-6 col-lg-6 col-sm-12 pl-0 pb-3" id="left">
                                <div class="widget-content-area  data-widgets pl-0 br-4">
                                    <div class="widget  t-customer-widget">
                                        <div class="media">
                                            <div class="icon ml-2 ">
                                                <!-- <i class="flaticon-star-half"></i> -->
                                                <i class="flaticon-calendar-1" style="background-color: #e99f9f;color: white;"></i>
                                            </div>
                                            <div class="">
                                                <p class="widget-text mb-0" style="color: black; font-size: 20px;">Visites Reportées</p>
                                                <b class="widget-numeric-value" style="font-size: 20px;"><span *ngIf="commercial_ratings == null">0</span>{{commercial_ratings}}</b>
                                            </div>
                                        </div>  
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-6 col-lg-6 col-sm-12 pl-0 pb-3" id="right">
                                <div class="widget-content-area  data-widgets pl-0 br-4">
                                    <div class="widget  t-income-widget">
                                        <div class="media">
                                            <div class="icon ml-2 ">
                                                <!-- <i class="flaticon-dollar-coin"></i> -->
                                                <i class="flaticon-single-tick" style="background-color: #61a4fd;color: white;" ></i>
                                            </div>
                                            <div class="">
                                                <p class="widget-text mb-0" style="color: black; font-size: 20px;">Visites Effectuées</p>
                                                <b class="widget-numeric-value"style="font-size: 20px;"><span *ngIf="done == null">0</span>{{done}}</b>
                                            </div>
                                        </div>  
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="" style="margin-top: 2%;">
                            <div class=""><div class=" col-xl-12 col-lg-12 col-sm-12 p-3 border-white rounded bg-light">
                                <form>
                                    <div class="row">
                                        <label class="col-lg-4 col-md-4 col-sm-12 h6 text-primary" style="white-space: nowrap">Membre</label>     
                                        <p class="col-lg-4 col-md-4 col-sm-12 h6" style="padding-left: 10%; color: black; white-space: nowrap">{{commercial_fullname}}</p>
                                    </div>
                                    <div class="row">
                                        <label class="col-lg-4 col-md-4 col-sm-12 h6 text-primary" style="white-space: nowrap">N°Téléphone</label>     
                                        <p class="col-lg-4 col-md-4 col-sm-12 h6" style="padding-left: 10%; color: black; white-space: nowrap">{{commercial_phone}}</p>
                                    </div>
                                    <div class="row">
                                        <label class="col-lg-4 col-md-4 col-sm-12 h6 text-primary" style="white-space: nowrap">Email</label>     
                                        <p class="col-lg-8 col-md-8 col-sm-12 h6" style="padding-left: 10%; color: black;word-wrap: break-word;">{{commercial_email}}</p>
                                    </div>
                                    <div class="row">
                                        <label class="col-lg-4 col-md-4 col-sm-12 h6 text-primary" style="white-space: nowrap">Profil</label>     
                                        <p class="col-lg-8 col-md-8 col-sm-12 h6" style="padding-left: 10%; color: black;word-wrap: break-word;">{{getProfile(commercial_profile)}}</p>
                                    </div>
                                </form>
                                </div>
                            </div>
                        </div>
                            <div class="col-lg-12 col-md-12 col-sm-12 col-12 row" style="margin-top: 3%; margin-left: inherit;" > 
                                <label class="switch s-success  mb-4 mr-2" >
                                    <input  type="checkbox" id="account" name="permission" >
                                    <span class="slider round" (click)="Permission()"></span>
                                </label>
                                <span  style="white-space: nowrap;">
                                    <span *ngIf="commercial_status == '9dbecf2631b52926e5dd1a89440ef908'">Compte actif</span>
                                    <span *ngIf="commercial_status == 'cff182167d5017c13d5178ca1836f2a7'">Compte inactif</span>
                                </span>
                                <div *ngIf="addOrUpdateLoading" class="cp-spinner cp-skeleton spinner_customers" style="margin-top: -3px;"></div> 
                            </div>
                        </div>
                    </div>
                </div>
            </div>  
            <div class="modal-footer md-button">
                <button type="button" class="btn btn-default btn-rounded mt-3 mb-3" data-dismiss="modal">Retour</button>
            </div>
        </div>
    </div>
</div>
<div id="historymodal" class="modal animated fadeInUp custo-fadeInUp" role="dialog">
    <div class="modal-dialog modal-xl">
        <!-- Modal content-->
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">Historique de <b>{{fullname_actions}}</b></h4>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">
                <div *ngIf="teamHistoLoading" class="cp-spinner cp-bubble" style="margin: auto;display: block;margin-top: 15%;
                    margin-bottom: 15%;"></div>
                <div class="statbox widget box box-shadow" *ngIf="!teamHistoLoading">
                    <div class="widget-content widget-content-area area_popin">
                        
                        <div class="media table-responsive">
                            <table id="alter_paginations" class="table table-striped table-bordered" style="width:100%">
                                <thead>
                                    <tr>
                                        <th>Client</th>
                                        <th>Action</th>
                                        <th>Date action</th>
                                        <th>Ajoutée par</th>
                                        <th>Date d'ajout</th>
                                        <th>Status</th>   
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let history of action">
                                        <td>{{history.action_added_to_customer}}</td>
                                        <td>{{history.action_description}}</td>
                                        <td>
                                            <span *ngIf="history.action_added_at == null">---</span>
                                            {{history.action_added_at | date: 'dd/MM/yyyy - HH:mm '}}
                                        </td>
                                        <td>{{history.action_added_by}}</td>
                                        <td>
                                            <span *ngIf="history.action_added_at == null">---</span>
                                            {{history.action_added_at | date: 'dd/MM/yyyy - HH:mm '}}
                                        </td>
                                        <td>
                                            <div class="col-xl-3 col-lg-4 col-md-2 col-sm-2 col-5 " id="status">
                                                <span *ngIf="history.visit_action_status=='Terminée'" style="display: inline-flex;">
                                                    <span class="dot dot-success align-self-center mr-2"></span>Effectuée
                                                </span>
                                                <span *ngIf="history.visit_action_status=='En cours'" style="display: inline-flex;">
                                                    <span class="dot dot-inprogress align-self-center mr-2"></span>En cours
                                                </span>
                                                <span *ngIf="history.visit_action_status=='Reportée'" style="display: inline-flex;">
                                                    <span class="dot dot-danger align-self-center mr-2"></span>Reportée
                                                </span>
                                                <span *ngIf="history.visit_action_status=='Planifiée'" style="display: inline-flex;">
                                                    <span class="dot dot-planifie align-self-center mr-2"></span>Planifiée
                                                </span>
                                                <span *ngIf="history.visit_action_status=='Créée'" style="display: inline-flex;">
                                                    <span class="dot dot-info align-self-center mr-2"></span>Créée
                                                </span>
                                                <span *ngIf="history.visit_action_status=='Annulée'" style="display: inline-flex;">
                                                    <span class="dot dot-annule align-self-center mr-2"></span>Annulée
                                                </span>
                                                <span *ngIf="history.visit_action_status=='Refusée'" style="display: inline-flex;">
                                                    <span class="dot dot-annule align-self-center mr-2"></span>Refusée
                                                </span>
                                                <span *ngIf="history.visit_action_status=='En attente de validation'" style="display: inline-flex;">
                                                    <span class="dot dot-att align-self-center mr-2"></span>En attente de validation
                                                </span>
                                                <span *ngIf="history.visit_action_status=='Brouillon'" style="display: inline-flex;">
                                                    <span class="dot dot-draft align-self-center mr-2"></span>Brouillon
                                                </span>
                                            </div>
                                        </td>  
                                    </tr>
                            </table>
                        </div>
                            
                    </div>
                </div>
            </div>
            <div class="text-center md-button">
                <button type="button" class="btn btn-default btn-rounded mt-3 mb-3 " data-dismiss="modal">Retour</button>
            </div>
        </div>
    </div>
</div>
<div id="planningmodal" class="modal animated fadeInUp custo-fadeInUp" role="dialog">
    <div class="modal-dialog modal-lg">
        <!-- Modal content-->
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">Semaine de <b class="text-primary">{{fullname_commercial}}</b></h4>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">
                <div *ngIf="teamPlanLoading" class="cp-spinner cp-bubble" style="margin: auto;display: block;margin-top: 15%;
                    margin-bottom: 15%;"></div>
                <span *ngIf="!teamPlanLoading">
                    <div *ngIf="program == 0" style="text-align:center;margin-top:10%;margin-bottom: 10%;">
                        <span stye>Aucune visite n'est planifiées</span>
                    </div>
                    <div  *ngFor="let com of program" class="mt-3">
                    <div class="pl-2 mb-2" style="background-color: #efefef;border-radius: 12px;">
                        <span style="font-size: large; display: inline-block; color: black;" class="media-heading text mt-sm-0 mt-5 mr-3">{{com.day_week | date: 'dd/MM/yyyy'}}</span>
                        <p *ngFor="let city of com.cities_to_visit" class="fruit on mb-0" style="font-size: small; display:inline-block ;">{{city}}</p>
                    </div>
                    <ul class="list-unstyled" *ngIf="!teamPlanLoading && com.visits !=null">
                        <li class="media-chat visit_customer">
                            <ul *ngFor="let visit of com.visits" class="list-unstyled">
                                <li class="media-chat" style="display: inline-flex !important;">
                                    <img *ngIf="visit.customer.customer_logo != null" class="logo_customer mr-2 ml-3 " [src]="'data:image/jpg;base64,'+visit.customer.customer_logo">
                                    <img *ngIf="visit.customer.customer_logo == null" class="logo_customer mr-2 ml-3 "  src="assets/img/logo.jpg">
                                    <div class="media-body">
                                        <h5 class="mt-0 mb-1">{{visit.customer.customer_rs}}</h5>
                                    </div>
                                </li>
                            </ul>
                        </li>
                    </ul>
                    <p style="text-align: center;" *ngIf="com.visits==null">Aucune visite n'est planifiée</p>
                    </div>
                </span>
            </div>
            <div class="modal-footer md-button">
                <button type="button" class="btn btn-dark btn-rounded mt-3 mb-3" data-dismiss="modal">Retour</button>
            </div>
        </div>
    </div>
</div>